class DrawerAccounts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.type !== triggerEl.dataset.type,
      )
    })

    this.els.trigger.elements.forEach((el) => {
      el.setAttribute(
        'aria-pressed',
        el.dataset.type === triggerEl.dataset.type,
      )
    })
  }
}

if (!customElements.get('drawer-accounts')) {
  customElements.define('drawer-accounts', DrawerAccounts)
}
